import PropTypes from 'prop-types';
import CategoryItem from './CategoryItem';
import ItemPanel from '../item-details/ItemPanel';
import LoginPanel from '../dashboard/LoginPanel';
import Modal from '~/js/components/global/Modal';
import ReactLoader from '~/js/components/global/ReactLoader';
import '~/js/modules/bootstrap-tabs';
import '~/js/libs/jquery.waypoint';

export default class EventTabs extends React.Component {
  static propTypes = {
    inspirationURLParameter: PropTypes.number,
    inspirationItems: PropTypes.array,
    inspirationEvents: PropTypes.array,
    countries: PropTypes.array,
    isMobile: PropTypes.bool,
    isAuthenticated: PropTypes.bool,
    fetchInspirationItems: PropTypes.func
  };
  static defaultProps = {
    inspirationItems: [],
    inspirationEvents: []
  };
  constructor() {
    super();
    this.state = {
      isReceptionItems: false,
      itemDetails: {},
      isSuccessAdded: false,
      wishListModified: '',
      accountInfo: {},
      viewMoreRequestBody: {},
      isSignUp: true
    };
  }
  componentDidMount() {
    if($('.cobrand').length) {
      $('#nav-tabs').addClass('hasCobrand');
    }
    $('#nav-tabs').waypoint({
      handler: () =>  {
        $('#nav-tabs').toggleClass('sticky');
      },
      offset: 35
    });
  }

  _toggleItemsToShow = (isReceptionItems) => {
    return () => {
      this.setState({ isReceptionItems });
    };
  };

  _filterItemsByEvent = (eventType) => {
    const currentEvent = (eventType) ? 'RECEPTION' : 'CEREMONY';
    const eventItems = this.props.inspirationItems.filter((el) => el.event === currentEvent);

    return eventItems;
  };

  _getCategories = (eventItems) => {
    const categories = eventItems.map(item => item.categoryName);

    return Array.from(new Set(categories));
  };

  _filterItemsByCategory = (eventItems, category) => eventItems.filter((el) => el.categoryName === category);

  _renderCategories = (categories, eventItems) => {
    return categories.map((category) => {

      const categoryItems = this._filterItemsByCategory(eventItems, category);

      return (<CategoryItem
        key={ category }
        categoryName= {category}
        categoryId= {categoryItems[0].categoryId}
        categoryItems={categoryItems}
        inspirationEvents={this.props.inspirationEvents}
        inspirationId={this.props.inspirationURLParameter}
        initialRows={categoryItems[0].displayedRows}
        isMobile={this.props.isMobile}
        countries={this.props.countries}
        modalUpdateHandler={this._updateItemDetail}
        isSuccessAddedHandler={this._isSuccessAddedHandler}
        getViewMoreRequestBody={this._getViewMoreRequestBody}
        userId={this.state.accountInfo.id}
        isReceptionItems={this.state.isReceptionItems}
      />);
    });
  };
  _updateItemDetail = (itemDetails) => {
    this.setState({ itemDetails });
    // this.forceUpdate();
  };
  _updateAccountInfo = (accountInfo) => {
    this.setState({ accountInfo });
  };
  _getViewMoreRequestBody = (viewMoreRequestBody) => {
    this.setState({viewMoreRequestBody});
  };
  _getModifiedWishList = (wishListModified) => {
    this.setState({ wishListModified });
    // this.forceUpdate();
  };
  _isSuccessAddedHandler = (isSuccessAdded) => {
    this.setState({ isSuccessAdded }, () => {
      $.magnificPopup.open({
        items: {
          src: '#item-modal',
          type: 'inline'
        }
      });
    });
    isSuccessAdded ? this.props.fetchInspirationItems() : null;
    $('.mfp-close').empty();
  };
  _handlerIsSignUp = (isSignUp = false) => {
    this.setState({isSignUp});
  };

  render() {
    const eventItems = this._filterItemsByEvent(this.state.isReceptionItems);
    const categories = this._getCategories(eventItems);
    const categoryContainers = this._renderCategories(categories, eventItems);

    return(
      <div className="collection-tabs container">
        <ul id="nav-tabs" className="nav nav-tabs" data-tabs="tabs">
          <li className="active"><a  href="#ceremony" data-toggle="tab" onClick={ this._toggleItemsToShow(false) }>Ceremony</a></li>
          <li><a href="#reception" data-toggle="tab" onClick={ this._toggleItemsToShow(true) }>Reception</a></li>
          <li className={`btn-action-wrapper wishlist txt-center ${this.props.isAuthenticated ? 'visible' : 'invisible'}`}>
            <a className="btn-action" href="/weddings/ideas/wishlist/">
              <i className="icon-reading" />view wishlists
            </a>
          </li>
          <li className="btn-action-wrapper all-catalog txt-center">
            <a className="btn-action all-catalog" href="/weddings/ideas/wishlist-catalog/">
              <i className="icon-arrow-right" />View All catalog items
            </a>
          </li>
        </ul>

        <div className="tab-content">
          <ReactLoader className={'sk-loader-ceremonyTab'}/>
          <div className="tab-pane active" id="ceremony">
            {this.state.isReceptionItems ? '' : categoryContainers}
          </div>
          <div className="tab-pane" id="reception">
            {this.state.isReceptionItems ? categoryContainers : ''}
          </div>
        </div>
        <Modal id="item-modal">
          <ReactLoader className={'sk-loader-item'}/>
          <ItemPanel
            itemData={this.state.itemDetails}
            isSignUpHandler={this._handlerIsSignUp}
            isSuccessAdded={this.state.isSuccessAdded}
            wishListModified={this.state.wishListModified}
            userId={this.state.accountInfo.id}
            modalUpdateHandler={this._updateItemDetail}
            isSuccessAddedHandler= {this._isSuccessAddedHandler}
          />
        </Modal>
        <Modal id="dashboard-modal">
          <LoginPanel
            isSignUp={this.state.isSignUp}
            handlerIsSignUp={this._handlerIsSignUp}
            isAddItem
            countries={this.props.countries}
            itemDetails={this.state.itemDetails}
            isSuccessAddedHandler={this._isSuccessAddedHandler}
            updateAccountInfo={this._updateAccountInfo}
            modalUpdateHandler={this._updateItemDetail}
            getModifiedWishList={this._getModifiedWishList}/>
        </Modal>
      </div>
    );
  }
}
